import { render, staticRenderFns } from "./MimdgFormHeader.vue?vue&type=template&id=d27ae98e"
import script from "./MimdgFormHeader.vue?vue&type=script&lang=js"
export * from "./MimdgFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports